<template>
    <div class="content-switches">
        <transition name="toggleSwitcher">
        <img 
            v-if="!isPsoriasisPage" 
            @click="switchContent('toPsoriasis')"
            class="content-switch content-switch__psoriasis content-switch--left"
            v-bind:src="$store.state.s3Link + require('../../../assets/switch-psoriasis.png')">
        </transition>
        <transition name="toggleSwitcher">
        <img 
            v-if="isPsoriasisPage" 
            @click="switchContent('toTremfya')"
            class="content-switch content-switch__tremfya content-switch--right"
            v-bind:src="$store.state.s3Link + require('../../../assets/switch-tremfya.png')">
        </transition>
    </div>
</template>

<script>
import { mapState } from 'vuex';
// import { VueScrollTo } from 'vue-scrollto';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['userAgent']),
    isPsoriasisPage() {
      return this.$route.meta.page === 'Psoriasis' ? true : false;
    }
  },
  methods: {
    switchContent(toSection) {
      let routePath = this.$route.path;
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      if (typeof routePath === 'object') {
        routePath = routePath.path;
      }

      if (toSection === 'toTremfya') {
        if (this.userAgent.device.isMobile) {
          this.$store.state.psoriasisScrollPos = top;
        }

        this.$store.commit('psoriasis_last_nav', routePath);
        this.$router.push(this.$store.state.tremfyaLastNav);
      } else if (toSection === 'toPsoriasis') {
        if (this.userAgent.device.isMobile) {
          this.$store.state.tremfyaScrollPos = top;
        }

        this.$store.commit('tremfya_last_nav', routePath);
        this.$router.push(this.$store.state.psoriasisLastNav);
      }
    }
  }
};
</script>

<style lang="scss" src="./ContentSwitches.scss">
</style>
